import useSWRMutation from 'swr/mutation';
import letrusAPI from 'APIs/letrusAPI/axiosInstance';
import {
  StartFocusModeLearningPathErrorResponse,
  StartFocusModeLearningPathPayload,
  StartFocusModeLearningPathResponse,
} from './types';

export function useStartFocusModeLearningPath() {
  return useSWRMutation<
    StartFocusModeLearningPathResponse,
    Error & {
      response?: {data?: StartFocusModeLearningPathErrorResponse};
    },
    string,
    StartFocusModeLearningPathPayload
  >(
    '/api/v1/new_learning_path_user_instances/focus_mode/start/',
    async (_, {arg}) => {
      const {learningPathUserInstanceId} = arg;

      const response = await letrusAPI(
        `/api/v1/new_learning_path_user_instances/${learningPathUserInstanceId}/focus_mode/start/`,
        {
          method: 'post',
        },
      );

      return response.data;
    },
    {
      throwOnError: false,
      revalidate: false,
    },
  );
}
